import { useState } from "react";

export const useChangeTracking = (wrapperData: any, selectedProduct: any[]) => {
  const [wrapperChanges, setWrapperChanges] = useState<Record<string, any>>({});
  const [productChanges, setProductChanges] = useState<Record<string, any>>({});
  const [hasWrapperChanges, setHasWrapperChanges] = useState(false);
  const [hasProductChanges, setHasProductChanges] = useState(false);

  const trackWrapperChange = (field: string, value: any) => {
    setWrapperChanges((prev) => {
      const newChanges = { ...prev, [field]: value };
      setHasWrapperChanges(Object.keys(newChanges).length > 0);
      return newChanges;
    });
  };

  const trackProductChange = (field: string, value: any, productId: string) => {
    setProductChanges((prev) => {
      const productKey = productId?.toString() || "unknown";
      const existingProductChanges = prev[productKey] || {};
      const newProductChanges = {
        ...prev,
        [productKey]: {
          ...existingProductChanges,
          [field]: value,
        },
      };
      const hasChanges = Object.keys(newProductChanges).some(
        (key) => Object.keys(newProductChanges[key]).length > 0,
      );
      setHasProductChanges(hasChanges);
      return newProductChanges;
    });
  };

  // ✅ Get all product changes including wrapper name changes
  const getAllChangedProducts = () => {
    const allChanges: Record<string, any> = {};
    
    // If wrapper name changed, mark all products for update
    if (wrapperChanges.name) {
      const productIds = selectedProduct.map((p: any) => p.id?.toString());
      productIds.forEach((id: string) => {
        if (id) {
          allChanges[id] = {
            ...(allChanges[id] || {}),
            name: wrapperChanges.name,
          };
        }
      });
    }
    
    // Merge with existing product changes
    Object.keys(productChanges).forEach((productId) => {
      allChanges[productId] = {
        ...(allChanges[productId] || {}),
        ...productChanges[productId],
      };
    });
    
    return allChanges;
  };

  const resetChanges = () => {
    setWrapperChanges({});
    setProductChanges({});
    setHasWrapperChanges(false);
    setHasProductChanges(false);
  };

  return {
    hasWrapperChanges,
    hasProductChanges,
    trackWrapperChange,
    trackProductChange,
    resetChanges,
    getChangedWrapperData: () => wrapperChanges,
    getChangedProductData: () => productChanges,
    getAllChangedProducts,
    setHasProductChanges,
  };
};